import VendorNav from "../Homepage/Components/VendorNav";
import { orangeButtonCentered } from "../../Constants/Styles";
import { LoginBackground } from "../../Constants/Backgrounds";

const VendorAlreadyLoggedIn = () => {
    return (
        <div className="flex flex-col h-screen">
            <VendorNav navbarColor="#26051C" />
            <div
                className="w-full h-full flex justify-center "
                style={{
                    backgroundImage: `url(${LoginBackground})`,
                    backgroundSize: 'cover',
                    position: 'relative'
                }}
            >
                <div className="absolute inset-0 bg-black opacity-5 z-0" />
                <div className="sm:mt-12 w-full xs:w-[32rem] h-[16rem]  bg-white flex flex-col z-40">
                    <div className="px-16 py-10">
                        <h2 className="mt-8 text-2xl font-semibold"> You are already logged in!</h2>

                        <div className="mt-12 w-full flex justify-center">
                            <button
                                className="w-fit h-fit mx-auto text-white bg-link hover:text-integrationRequestTextHover hover:bg-charmHover rounded-full text-[18px] font-proximanova px-8 py-2 1.5xl:px-10 1.5xl:py-4"
                                onClick={() => window.location.href = '/vendors/profile'}
                            >
                                Return to Your Profile
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}


export default VendorAlreadyLoggedIn;